import { useEffect, useState } from 'react';
import { replaceNonDigits } from 'utilities/global';

export const useNumericValidator = ({ limit }) => {
  const [oldValue, setOldValue] = useState('');
  const [oldCursor, setOldCursor] = useState(0);
  const resetState = () => {
    setOldValue('');
    setOldCursor(0);
  };
  useEffect(() => {
    resetState();
  }, [limit]);

  const onKeyDown = e => {
    setOldValue(e.target.value);
    setOldCursor(e.target.selectionEnd);
  };

  const onInput = e => {
    let newValue = replaceNonDigits(e.target.value);
    const moreThanLimit = limit && newValue.length > limit;
    if (moreThanLimit) {
      newValue = newValue.slice(0, limit);
    }
    const newCursorPosition = oldCursor + (newValue.length - oldValue.length);
    if (newValue !== '') {
      e.target.value = newValue;
    } else {
      e.target.value = '';
    }
    e.target.setSelectionRange(newCursorPosition, newCursorPosition);
  };

  return {
    onKeyDown,
    onInput
  };
};
